document.addEventListener('DOMContentLoaded', function () {
    const donationInput = document.getElementById('addDonationModel_DonationAmount');
    const buttons = document.querySelectorAll('.suggested-amounts__button');

    buttons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const value = parseFloat(button.textContent.replace('£','').trim());
            if (!isNaN(value)) {
                donationInput.value = value.toFixed(2);
            }
        });
    });
});